import tocbot from "tocbot";
import Chevron from "img/chevron.svg";

type DocIdProps = {
    text: string;
    existingIds: Set<string>;
};

type TocElement = HTMLElement;

type ScrollProps = {
    tocElement: TocElement;
    frm: Element | null;
    topStop: number;
    endStop: number;
};

function applyClass(
    tocElement: TocElement,
    addClass: string,
    removeClasses: string[]
) {
    if (tocElement.classList.contains(addClass)) return;
    removeClasses.forEach((cls) => tocElement.classList.remove(cls));
    tocElement.classList.add(addClass);
}

function pagePosition({ frm, topStop, endStop, tocElement }: ScrollProps) {
    if (!frm) return;
    const frmPos = frm.getBoundingClientRect();

    if (frmPos.top < topStop && frmPos.bottom > endStop)
        applyClass(tocElement, "page", ["endFade", "top"]);
    if (frmPos.top > topStop)
        applyClass(tocElement, "top", ["endFade", "page"]);
    if (frmPos.bottom <= endStop) applyClass(tocElement, "endFade", ["page"]);
}

(function () {
    "use strict";

    function generateIdFromText({ text, existingIds }: DocIdProps) {
        const baseId = text
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "");
        let uniqueId = baseId;
        let counter = 1;
        while (existingIds.has(uniqueId) || document.getElementById(uniqueId)) {
            uniqueId = `${baseId}-${counter++}`;
        }
        return uniqueId;
    }

    function addIdToHeadingTags() {
        const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
        const existingIds = new Set(
            [...document.querySelectorAll("[id]")].map((el) => el.id)
        );

        headings.forEach((heading) => {
            if (!heading.id) {
                heading.id = generateIdFromText({
                    text: heading.textContent || "",
                    existingIds,
                });
                existingIds.add(heading.id);
            }
        });
    }

    function initTOC() {
        const tocElement = document.querySelector("[data-toc]") as HTMLElement;
        const tocFlex = document.querySelector(
            "[data-toc-flex]"
        ) as HTMLElement;

        if (!tocElement) return;

        const frameMobile = window.innerWidth < 1080;
        const tocDepth = frameMobile
            ? 6
            : Number(tocElement.dataset.tocDepth || 0);

        addIdToHeadingTags();

        tocbot.init({
            tocSelector: ".toc-menu",
            contentSelector: ".js-toc-content",
            headingSelector: "h2, h3, h4",
            positionFixedSelector: "[data-toc]",
            activeLinkClass: "is-active-link",
            positionFixedClass: "toc-position-fixed",
            fixedSidebarOffset: tocElement.getBoundingClientRect().top,
            collapseDepth: tocDepth,
        });

        const button = document.createElement("button");
        button.classList.add("toc-button");
        button.setAttribute("tabindex", "0");
        const img = document.createElement("img");
        img.src = Chevron;
        button.append(img);
        tocElement.insertBefore(button, tocElement.firstChild);

        button.addEventListener("click", () => {
            tocFlex?.classList.toggle("hidelist");
        });

        const frm = document.querySelector(".js-toc-content");
        const props = {
            frm,
            topStop: 0,
            endStop: window.outerHeight,
            tocElement,
        };

        pagePosition(props);
        document.addEventListener("scroll", () => {
            pagePosition(props);
            if (tocElement.classList.contains("page")) {
                const active = document.querySelector(".is-active-link");
                if (active) {
                    tocElement.scrollTop =
                        active.getBoundingClientRect().top -
                        200 +
                        tocElement.scrollTop;
                }
            }
        });
    }

    initTOC();
})();
